import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/design-tokens.css';
import './index.css';
import App from './App';
import ReportPrintable from './components/ReportPrintable/ReportPrintable';
import ListaPrintable from './components/ListaPrintable/ListaPrintable';
import { installFetchInterceptor } from './utils/fetchInterceptor';
import { initSentry, AppErrorBoundary } from './utils/sentry';

// P4 — Observabilidade: inicializa o Sentry ANTES de qualquer render
// (no-op se REACT_APP_SENTRY_DSN não estiver definido no build).
initSentry();

// Sessão 17 C2 — instala o interceptor global de fetch ANTES de qualquer
// requisição: em 401, renova o access token via /auth/refresh e refaz a
// chamada (transparente para todos os componentes que fazem fetch).
installFetchInterceptor();

// Rota standalone para relatório imprimível (texto selecionável via window.print()).
// Path matching manual — react-router-dom não está montado neste app.
// URL: /relatorio-pdf/<id>?sections=key1,key2 (sections opcional; sem param = todas)
// Sem layout/UserHeader/sidebar — só o documento limpo, otimizado para print.
const isPrintableRoute = window.location.pathname.startsWith('/relatorio-pdf/');
// #78b: rota standalone do PDF da LISTA de NCs (/exportar-ncs?cliente_id=..&<filtros>).
const isListaExportRoute = window.location.pathname.startsWith('/exportar-ncs');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      {isPrintableRoute ? <ReportPrintable />
        : isListaExportRoute ? <ListaPrintable />
        : <App />}
    </AppErrorBoundary>
  </React.StrictMode>
);
